import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IUploadedProForma } from 'types/db/UploadedProForma';

interface IParams {
    organizationUuid: string;
    dealId: number;
    uploadedProFormaId: number;
}

const getUploadedProForma = async ({ organizationUuid, dealId, uploadedProFormaId }: IParams): Promise<IUploadedProForma> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.UPLOADED_PRO_FORMAS_BY_DEAL_AND_ID(organizationUuid, dealId, uploadedProFormaId)}`);
    return response.data;
};

const useGetUploadedProForma = (organizationUuid: string, dealId: number, uploadedProFormaId: number, options?: any) => useQuery<IUploadedProForma>({
    queryKey: ['UploadedProForma', organizationUuid, dealId, uploadedProFormaId],
    queryFn: () => getUploadedProForma({ organizationUuid, dealId, uploadedProFormaId }),
    ...options,
});

export default useGetUploadedProForma;
